import { GET_FRONTBACKCOURSES_LOADING, GET_FRONTBACKCOURSES_SUCCESS, GET_FRONTBACKCOURSES_ERROR } from "../../../constant/actionTypes";

const getFrontAndBackCoursesReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_FRONTBACKCOURSES_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case GET_FRONTBACKCOURSES_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response,
            };
            return obj;
        }
        case GET_FRONTBACKCOURSES_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default getFrontAndBackCoursesReducer;